<div class="container">
    <div class="block-title">
        <div class="title">{{ 'SHARED.ROUTE.ACTIVE.INCIDENT.STANDSTILL.CAPTION' | translate }}</div>
        <div class="subtitle">{{ 'SHARED.ROUTE.ACTIVE.INCIDENT.STANDSTILL.HELP' | translate }}</div>
    </div>

    <div class="buttons-group">
        <div class="action-card card-pricked" [ngClass]="{'selected': iHavePricked}" (click)="onIHavePricked()">
            <div class="icon-wrapper">
                <i class="fa fa-life-ring" aria-hidden="true"></i>
            </div>
            <div class="card-body">
                <div class="card-title">{{ 'SHARED.ROUTE.ACTIVE.INCIDENT.HAVEPINCKED' | translate }}</div>
            </div>
            <i class="fa arrow-right" [ngClass]="iHavePricked ? 'fa-check-square-o' : 'fa-square-o'" aria-hidden="true"></i>
        </div>
    </div>

    <div class="block-form">
        <textarea-component class="textarea" [readonly]="readonly" [(ngModel)]="comment" name="comment"
            placeholder="{{ 'SHARED.ROUTE.ACTIVE.INCIDENT.COMMENT.PLACEHOLDER' | translate }}">
        </textarea-component>
    </div>

    <div class="block-time">
        <div class="prompt">{{ 'SHARED.ROUTE.ACTIVE.INCIDENT.STANDSTILL.FORECAST' | translate }}</div>
        <time-caret [(ngModel)]="time" [min]="mintime"></time-caret>
        <button class="btn-external warning" (click)="onMoreTime()" [disabled]="!isValid() || readonlySend">
            {{ 'SHARED.ROUTE.ACTIVE.INCIDENT.MORETIME' | translate }}</button>
    </div>

    <div class="block-buttons">
        <button class="btn-external danger" (click)="onReport()" [disabled]="!isValid() || readonlySend">
            {{ 'SHARED.ROUTE.ACTIVE.INCIDENT.REPORT' | translate }}</button>
        <button class="btn-external success" (click)="onResolved()" [disabled]="!isValid() || readonlySend">
            {{ 'SHARED.ROUTE.ACTIVE.INCIDENT.RESOLVED' | translate }}</button>
    </div>
</div>
